import { DateTime } from 'luxon';
import { RRule } from 'rrule';

/**
 * @param {String|DateTime} dateString
 * @return {String|DateTime}
 */
function parse(dateString) {
    if (dateString === undefined || dateString === null || dateString === '') {
        return '';
    }
    if (dateString instanceof DateTime) {
        return dateString;
    }

    return DateTime.fromISO(dateString);
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @returns {DateTime}
 */
function getCurrentPeriodStart(date, initial) {
    if (date < initial) {
        throw new Error(`Not compatible with dates before ${initial.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}`);
    }

    const rrule = new RRule({
            freq: RRule.WEEKLY,
            interval: 2,
            wkst: RRule.SU,
            byweekday: RRule.SU,
            dtstart: initial.toJSDate(),
            count: initial.diffNow('week'),
        }),
        occurrences = rrule.between(initial.toJSDate(), date.toJSDate(), true);

    return DateTime.fromJSDate(occurrences[occurrences.length - 1]);
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @returns {DateTime}
 */
function getCurrentPeriodEnd(date, initial) {
    return getCurrentPeriodStart(date, initial).plus({ week: 2 }).endOf('week').minus({ days: 1 });
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @param {Number} nth
 * @returns {DateTime}
 */
function getNthPeriodStart(date, initial, nth = 1) {
    return getCurrentPeriodStart(date.plus({ weeks: nth * 2 }), initial);
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @param {Number} nth
 * @returns {DateTime}
 */
function getNthPeriodEnd(date, initial, nth = 1) {
    return getCurrentPeriodEnd(date.plus({ weeks: nth * 2 }), initial);
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @returns {DateTime}
 */
function getPreviousPeriodStart(date, initial) {
    return getNthPeriodStart(date, initial, -1);
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @returns {DateTime}
 */
function getPreviousPeriodEnd(date, initial) {
    return getNthPeriodEnd(date, initial, -1);
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @returns {DateTime}
 */
function getNextPeriodStart(date, initial) {
    return getNthPeriodStart(date, initial, 1);
}

/**
 * @param {DateTime} date
 * @param {DateTime} initial
 * @returns {DateTime}
 */
function getNextPeriodEnd(date, initial) {
    return getNthPeriodEnd(date, initial, 1);
}

export {
    parse as default,
    getCurrentPeriodStart,
    getCurrentPeriodEnd,
    getNthPeriodStart,
    getNthPeriodEnd,
    getPreviousPeriodStart,
    getPreviousPeriodEnd,
    getNextPeriodStart,
    getNextPeriodEnd,
};
